// ============================================================
// cf-tabs.js � CF.tabs (tab switching via data-tab-target)
// Load sebelum cf-modal.js pada halaman yang menggunakan tabs.
//
// Dependencies: site.js
//
// Usage (cshtml):
//   <div class="cf-tabs" data-tab-group="modalId">
//       <button class="cf-tab active" data-tab-target="#panel1">Tab 1</button>
//       <button class="cf-tab"        data-tab-target="#panel2">Tab 2</button>
//   </div>
//   <div id="panel1" class="cf-tab-content">...</div>
//   <div id="panel2" class="cf-tab-content" style="display:none">...</div>
// ============================================================

window.CF = window.CF || {};

(function () {
    'use strict';

    // ????????????????????????????????????????????????????????
    // Internal helpers
    // ????????????????????????????????????????????????????????
    function _activate(tabBtn) {
        var targetSel = tabBtn.getAttribute('data-tab-target');
        if (!targetSel) return;

        var tabBar = tabBtn.closest('.cf-tabs');
        if (!tabBar) return;

        // Deactivate all tabs in the same bar
        tabBar.querySelectorAll('.cf-tab').forEach(function (btn) {
            btn.classList.remove('active');
        });

        // Hide all panels associated with this tab bar
        tabBar.querySelectorAll('.cf-tab').forEach(function (btn) {
            var sel = btn.getAttribute('data-tab-target');
            if (!sel) return;
            var panel = document.querySelector(sel);
            if (panel) panel.style.display = 'none';
        });

        // Activate the clicked tab and show its panel
        tabBtn.classList.add('active');
        var activePanel = document.querySelector(targetSel);
        if (activePanel) activePanel.style.display = '';
    }

    // ????????????????????????????????????????????????????????
    // Click delegation � handles all .cf-tab buttons globally
    // ????????????????????????????????????????????????????????
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.cf-tab');
        if (btn) _activate(btn);
    });

    // ????????????????????????????????????????????????????????
    // CF.tabs public API
    // ????????????????????????????????????????????????????????
    CF.tabs = {
        // Reset all tab groups inside a container (by group name = element id)
        reset: function (groupName) {
            var container = document.getElementById(groupName);
            if (!container) return;

            container.querySelectorAll('.cf-tabs[data-tab-group]').forEach(function (tabBar) {
                var firstTab = tabBar.querySelector('.cf-tab');
                if (firstTab) _activate(firstTab);
            });
        },

        // Activate a specific tab inside a group
        activate: function (groupName, targetSelector) {
            var container = document.getElementById(groupName);
            if (!container) return;

            var btn = container.querySelector('.cf-tab[data-tab-target="' + targetSelector + '"]');
            if (btn) _activate(btn);
        }
    };

})();
